export const TIMELINE_MANAGER_ACTIONS = {
  DATASET_LOADING_STARTED: 'LOADING_STARTED',
  ERROR_THROWN: 'ERROR_THROWN',
  DATASET_LOADED: 'DATASET_LOADED',
  DATASET_ADDED: 'DATASET_ADDED'
};
export const TICK_ACTIONS = {
  INIT: 'INIT',
  PLAY_PAUSE: 'PLAY_PAUSE',
  TICK_ERROR: 'TICK_ERROR',
  TICKED: 'TICKED',
  TICKING: 'TICKING'
};